'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPromise = isPromise;
/*
   If it walks like a duck and quacks like a duck...
 */
function isPromise(result) {
  return result && (result instanceof Promise || typeof result.then === 'function' && typeof result.catch === 'function');
}
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/function-tree/lib/utils.js
// module id = 239
// module chunks = 0